<template>
  <el-dialog
    title="提示"
    :visible.sync="visible"
    class="approveDialogWrap"
    width="30%"
    :before-close="handleClose"
  >
    <el-form
      :model="approveForm"
      :rules="rules"
      ref="approveForm"
      label-width="60px"
      class="contactsForm"
    >
      <div class="AddSupplierAContent">
        <el-row>
          <el-col :span="24">
            <el-form-item label="审批结果" prop="status" label-width="80px">
              <el-radio-group
                v-model="approveForm.status"
                style="display: flex"
              >
                <el-radio
                  v-for="item in options"
                  :label="item.value"
                  :key="item.value"
                  style="margin: 14px 20px"
                  >{{ item.label }}</el-radio
                >
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row v-if="subapproveType === 'TotalContract' && islastApproveUser">
          <el-col :span="20">
            <el-form-item label="项目部" label-width="140px">
              <el-cascader
                v-model="deptIds"
                :options="subDeptList"
                :props="defaultProps"
                @change="handleChange"
                placeholder="-请选择-"
                @active-item-change="handleChange"
                change-on-select
                style="width: 60%"
              ></el-cascader>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="approveType === 'GENERAL_CONTRACT' && islastApproveUser">
          <el-col :span="20">
            <el-form-item label="项目经理" label-width="140px">
              <el-select
                v-model="approveForm.chargeUserId"
                placeholder="-请选择-"
                filterable
                style="width: 60%"
              >
                <el-option
                  :label="item.displayName"
                  :value="item.id"
                  v-for="(item, index) in ProjectGMList"
                  :key="index"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row> -->
        <el-row>
          <el-col :span="24">
            <el-form-item label="审批意见" label-width="80px" prop="opinion">
              <el-input
                type="textarea"
                :rows="4"
                placeholder="请输入内容"
                v-model="approveForm.opinion"
                maxlength="200"
                size="medium"
                show-word-limit
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="handleConfirm()">确定</el-button>
      <!-- <el-button type="primary" @click="handleConfirm(4)">审批拒绝</el-button> -->
      <el-button type="info" @click="handleClose">取 消</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "dialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      opinion: "",
      //审批form
      approveForm: {
        status: 3,
        // chargeUserId: null, // 项目经理id
        itemId: 0, //对应审批对象id
        approveUserId: "", //审批人id
        deptId: "", //部门id
        opinion: "", //审批意见
        type: this.approveType, //审批类型
      },
      options: [
        {
          label: "通过",
          value: 3,
        },
        {
          label: "驳回",
          value: 4,
        },
      ],
      rules: {
        status: [
          { required: true, message: "请选择审批结果", trigger: "blur" },
        ],
        opinion: [
          { required: true, message: "请输入审批意见", trigger: "blur" },
        ],
      },
    };
  },

  methods: {
    handleConfirm() {
      // if (!this.opinion) {
      //   this.$message.warning("请输入审批意见");
      //   return;
      // }
      this.$refs["approveForm"].validate((valid) => {
        if (valid) {
          this.$emit("handleChange", true, this.approveForm);
          this.approveForm = {
            status: 3,
            // chargeUserId: null, // 项目经理id
            itemId: 0, //对应审批对象id
            approveUserId: "", //审批人id
            deptId: "", //部门id
            opinion: "", //审批意见
          };
        }
      });
    },
    handleClose() {
      this.$emit("handleChange", false, {});
      this.approveForm = {
        status: 3,
        // chargeUserId: null, // 项目经理id
        itemId: 0, //对应审批对象id
        approveUserId: "", //审批人id
        deptId: "", //部门id
        opinion: "", //审批意见
      };
    },
  },
};
</script>

<style scoped lang="scss">
.approveDialogWrap {
  .backWrap {
    // display: flex;
    margin: 10px 0;
    align-items: center;

    .label {
      width: 60px;
    }

    .content {
      flex: 1;
    }
  }

  .dialog-footer {
    text-align: center;
    width: 100%;
    display: inline-block;
  }
}
</style>
